import AuthService from '@/services/auth/auth.service';

export default class RouterService {
    constructor() {
        this.authService = new AuthService();
    }

    getHomeRoute() {
        const tokenData = this.authService.getDecoded();
        const roles = tokenData.roles;

        if (roles.includes('admin')) {
           return '/admin';
        } else if (roles.includes('teacher')) {
            return '/teacher';
        } else {
            return '/student';
        }
    }
}
